export const getServicesData = (t) => {
  const makeBody = (key) =>
    t(key)
      .split('\n\n')
      .map((paragraph) => paragraph.trim())
      .filter(Boolean);

  const publicUrl = process.env.PUBLIC_URL || '';
  const imageBase = `${publicUrl}/images`;

  return [
    {
      id: 'fund-raised-donation',
      slug: 'fund-raised-donation',
      image: `${imageBase}/image9.jpeg`,
      heroImage: `${imageBase}/image9.jpeg`,
      title: t('service_card_frd_title'),
      description: t('service_card_description'),
      intro: t('service_detail_frd_intro'),
      body: makeBody('service_detail_frd_body'),
      highlights: [
        {
          title: t('service_detail_frd_highlight_1_title'),
          text: t('service_detail_frd_highlight_1_text')
        },
        {
          title: t('service_detail_frd_highlight_2_title'),
          text: t('service_detail_frd_highlight_2_text')
        }
      ]
    },
    {
      id: 'development-programs',
      slug: 'development-programs',
      image: `${imageBase}/image10.jpeg`,
      heroImage: `${imageBase}/image10.jpeg`,
      title: t('service_card_dp_title'),
      description: t('service_card_description'),
      intro: t('service_detail_dp_intro'),
      body: makeBody('service_detail_dp_body'),
      highlights: [
        {
          title: t('service_detail_dp_highlight_1_title'),
          text: t('service_detail_dp_highlight_1_text')
        },
        {
          title: t('service_detail_dp_highlight_2_title'),
          text: t('service_detail_dp_highlight_2_text')
        }
      ]
    },
    {
      id: 'child-medical-research',
      slug: 'child-medical-research',
      image: `${imageBase}/image11.jpeg`,
      heroImage: `${imageBase}/image11.jpeg`,
      title: t('service_card_cmr_title'),
      description: t('service_card_description'),
      intro: t('service_detail_cmr_intro'),
      body: makeBody('service_detail_cmr_body'),
      highlights: [
        {
          title: t('service_detail_cmr_highlight_1_title'),
          text: t('service_detail_cmr_highlight_1_text')
        },
        {
          title: t('service_detail_cmr_highlight_2_title'),
          text: t('service_detail_cmr_highlight_2_text')
        }
      ]
    },
    {
      id: 'medical-treatment-help',
      slug: 'medical-treatment-help',
      image: `${imageBase}/image12.jpeg`,
      heroImage: `${imageBase}/image12.jpeg`,
      title: t('service_card_mth_title'),
      description: t('service_card_description'),
      intro: t('service_detail_mth_intro'),
      body: makeBody('service_detail_mth_body'),
      highlights: [
        {
          title: t('service_detail_mth_highlight_1_title'),
          text: t('service_detail_mth_highlight_1_text')
        },
        {
          title: t('service_detail_mth_highlight_2_title'),
          text: t('service_detail_mth_highlight_2_text')
        }
      ]
    }
  ];
};
